<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToForm'
});
</script>
<template>
	<div class="to-form" :flex="flex ? flex : null" :class="setClass" :style="setStyle">
		<div ref="toForm" class="to-form-list">
			<slot></slot>
			<div v-if="props.submitPosition === 'corner'" class="to-form-item is-placeholder"></div>
			<div v-if="slots.submit" class="to-form-submit" :style="submitStyle">
				<slot name="submit"></slot>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount, provide, useSlots, watch } from 'vue'


const props = defineProps({
	flex: Boolean,
	labelWidth: {
		type: [Number, String],
		default: ''
	},
	labelPosition: {
		type: String,
		default: 'left'
	},
	col: {
		type: [Number, String],
		default: 1
	},
	submitPosition: {
		type: String,
		default: ''
	},
	type: {
		type: String,
		default: ''
	},
	dir: {
		type: String,
		default: ''
	},
	mode: {
		type: String,
		default: ''
	},
	valueWidth: {
		type: String,
		default: ''
	},
	space: {
		type: [Number, String],
		default: ''
	},
	spaceX: {
		type: [Number, String],
		default: ''
	},
	spaceY: {
		type: [Number, String],
		default: ''
	},
	comparable: Boolean
})

const toForm = ref<HTMLElement | null>(null)
const slots = useSlots()
const items = ref<any[]>([])
const maxLabelWidth = ref(0)

// 响应式引用，用于 provide 给子组件
const labelWidthRef = ref(props.labelWidth)
const labelPositionRef = ref(props.labelPosition)
const spaceRef = ref(props.space)
const spaceXRef = ref(props.spaceX)
const spaceYRef = ref(props.spaceY)
const valueWidthRef = ref(props.valueWidth)

const adjust = () => {
	setTimeout(() => {
		let maxWidth = 0
		items.value.forEach(item => {
			if (item?.$refs?.label) {
				item.$refs.label.style.width = ''
			}
		})
		items.value.forEach(item => {
			const label = item?.$refs?.label
			if (label && label.clientWidth > maxWidth) {
				maxWidth = label.clientWidth
			}
		})
		items.value.forEach(item => {
			if (item?.$refs?.label) {
				item.$refs.label.style.width = `${maxWidth + 1}px`
			}
		})
		maxLabelWidth.value = maxWidth + 1
	}, 200)
}

const setClass = computed(() => {
	const arr: string[] = []
	if (props.col) {
		arr.push('is-col')
		arr.push(`col-${props.col}`)
	}
	if (props.submitPosition) arr.push(`submit-position-${props.submitPosition}`)
	if (props.mode) arr.push(`mode-${props.mode}`)
	if (props.dir) arr.push(`dir-${props.dir}`)
	if (props.valueWidth) arr.push(`value-width-${props.valueWidth}`)
	if (props.labelPosition) arr.push(`label-position-${props.labelPosition}`)
	return arr
})

const setStyle = computed(() => {
	const style: Record<string, string> = {}
	if (props.space) {
		style.gap = props.space + 'em'
	}
	if (props.spaceX) {
		style['--gap-x'] = props.spaceX + 'em'
	}
	if (props.spaceY) {
		style['--gap-y'] = props.spaceY + 'em'
	}
	return style
})

const submitStyle = computed(() => {
	if (props.submitPosition === 'item') {
		if (props.labelWidth === 'max') {
			return { marginLeft: maxLabelWidth.value + 'px' }
		} else {
			return { marginLeft: props.labelWidth + 'em' }
		}
	}
	return {}
})

// 监听 props 变化，更新响应式引用
watch(
	() => props.labelWidth,
	newVal => {
		labelWidthRef.value = newVal
		if (newVal === 'max') {
			adjust()
		}
	}
)

watch(
	() => props.labelPosition,
	newVal => {
		labelPositionRef.value = newVal
	}
)

watch(
	() => props.space,
	newVal => {
		spaceRef.value = newVal
	}
)

watch(
	() => props.spaceX,
	newVal => {
		spaceXRef.value = newVal
	}
)

watch(
	() => props.spaceY,
	newVal => {
		spaceYRef.value = newVal
	}
)

watch(
	() => props.valueWidth,
	newVal => {
		valueWidthRef.value = newVal
	}
)

onMounted(() => {
	if (props.labelWidth === 'max') {
		window.addEventListener('resize', adjust)
		adjust()
	}
})

onBeforeUnmount(() => {
	if (props.labelWidth === 'max') {
		window.removeEventListener('resize', adjust)
	}
})

// provide current instance
provide('ToForm', {
	labelWidth: labelWidthRef,
	labelPosition: labelPositionRef,
	space: spaceRef,
	spaceX: spaceXRef,
	spaceY: spaceYRef,
	submitPosition: props.submitPosition,
	items: items.value,
	type: props.type,
	comparable: props.comparable,
	valueWidth: valueWidthRef
})
</script>
